module.exports = __webpack_public_path__ + "static/media/left-arrow-small-black.d0d97a78.svg";